var map = {
	"./airkit.svg": 93847,
	"./amazon.svg": 68651,
	"./aws.svg": 85742,
	"./azure.svg": 83300,
	"./bing.svg": 81237,
	"./bitbucket.svg": 42526,
	"./c.svg": 54210,
	"./chrome.svg": 62677,
	"./cplusplus.svg": 56666,
	"./csharp.svg": 48314,
	"./dart.svg": 33124,
	"./disabled.svg": 83675,
	"./edge.svg": 87736,
	"./erlang.svg": 42450,
	"./firefox.svg": 93002,
	"./github.svg": 69554,
	"./gitlab.svg": 65562,
	"./go.svg": 23221,
	"./google.svg": 46270,
	"./graph.svg": 98049,
	"./heap.svg": 31025,
	"./insomnia.svg": 9395,
	"./intercom.svg": 41354,
	"./java.svg": 34275,
	"./json.svg": 15021,
	"./koala.svg": 29223,
	"./localize.svg": 41346,
	"./node.svg": 44483,
	"./openapi.svg": 75709,
	"./opera.svg": 38472,
	"./php.svg": 87601,
	"./postman.svg": 29687,
	"./powershell.svg": 67316,
	"./python.svg": 70121,
	"./readme.svg": 63697,
	"./recaptcha.svg": 34818,
	"./ruby.svg": 35099,
	"./safari.svg": 97071,
	"./segment.svg": 11894,
	"./shell.svg": 20468,
	"./slack.svg": 92417,
	"./speakeasy.svg": 95017,
	"./stainless.svg": 84757,
	"./swagger.svg": 74361,
	"./swift.svg": 79556,
	"./typekit.svg": 43497,
	"./warning.svg": 77297,
	"./zendesk.svg": 78525
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4169;
module.exports = webpackAsyncContext;